import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import clsx from 'clsx';

export const Route = createFileRoute('/admin/dictionary')({
  component: DictionaryLayout,
});

const SUBTABS = [
  { to: '/admin/dictionary', label: 'Review', exact: true },
  { to: '/admin/dictionary/list', label: 'Browse', exact: false },
] as const;

function DictionaryLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">Dictionary</h1>
        <p className="mt-1 text-sm text-nova-muted-foreground">
          Review pending extracted terms or browse entries by review status.
        </p>
      </div>

      <nav className="flex gap-1 rounded-lg border border-nova-border bg-nova-muted/80 p-1">
        {SUBTABS.map((tab) => {
          const active = tab.exact
            ? pathname === tab.to || pathname === `${tab.to}/`
            : pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={clsx(
                'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
                active
                  ? 'bg-nova-card text-nova-foreground shadow-sm'
                  : 'text-nova-muted-foreground hover:text-nova-foreground'
              )}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}
